<ng-container
  *ngIf="
    orderProductUnavailableViewModel$
      | async as orderProductUnavailableViewModel
  "
>
  <ion-col>
    <div class="opu-container">
      <ion-row>
        <ion-col>
          <p class="orders-product-unavailable">
            <ion-label
              [attr.data-cy]="
                'notification-details-' +
                orderProductUnavailableViewModel?.notification?.alertBatchId +
                '-order-numbers'
              "
            >
              {{ 'i18n.common.order' | translate }} #{{
                orderProductUnavailableViewModel?.warehouseCutsOrderNbrs?.join(
                  ', #'
                )
              }}
            </ion-label>
          </p>
          <ion-label
            [attr.data-cy]="
              'notification-details-' +
              orderProductUnavailableViewModel?.notification?.alertBatchId +
              '-customer-name'
            "
            class="opu-description"
          >
            {{
              orderProductUnavailableViewModel?.notification?.customerName
                | titlecase
            }}
          </ion-label>
          <ion-label
            [attr.data-cy]="
              'notification-details-' +
              orderProductUnavailableViewModel?.notification?.alertBatchId +
              '-customer-number'
            "
            class="opu-description"
          >
            (ID
            {{
              orderProductUnavailableViewModel?.notification?.customerNumber
            }})
          </ion-label>
          <div class="opu-pills-container">
            <ion-item>
              <ion-badge
                data-cy="notification-details-unavailable-products-count"
                mode="ios"
                class="opu-pill-unavailable-count"
              >
                {{ orderProductUnavailableViewModel?.unavailableProducts }}
              </ion-badge>
              <ion-label class="opu-pills-label">
                {{ 'i18n.notifications.warehouseCuts.unavailable' | translate }}
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-badge
                data-cy="notification-details-substituted-products-count"
                mode="ios"
                class="opu-pill-substituted-count"
              >
                {{ orderProductUnavailableViewModel?.substitutedProducts }}
              </ion-badge>
              <ion-label class="opu-pills-label">
                {{ 'i18n.notifications.warehouseCuts.substituted' | translate }}
              </ion-label>
            </ion-item>
          </div>
          <ion-label
            [attr.data-cy]="
              'notification-details-' +
              orderProductUnavailableViewModel?.notification?.alertBatchId +
              '-description'
            "
            class="opu-description"
            *ngIf="
              orderProductUnavailableViewModel?.unavailableProducts > 0 ||
              orderProductUnavailableViewModel?.addedToCartProducts > 0
            "
          >
            {{ 'i18n.notifications.warehouseCuts.description' | translate }}
          </ion-label>
          <ion-label
            [attr.data-cy]="
              'notification-details-' +
              orderProductUnavailableViewModel?.notification?.alertBatchId +
              '-description'
            "
            class="opu-description"
            *ngIf="
              orderProductUnavailableViewModel?.substitutedProducts > 0 &&
              orderProductUnavailableViewModel?.unavailableProducts === 0 &&
              orderProductUnavailableViewModel?.addedToCartProducts === 0
            "
          >
            {{
              'i18n.notifications.warehouseCuts.descriptionSubOnly' | translate
            }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row class="opu-details-section">
        <ion-col>
          <ion-accordion-group
            class="opu-sections"
            value="unavailable"
            *ngIf="
              orderProductUnavailableViewModel?.unavailableProducts > 0 ||
              orderProductUnavailableViewModel?.addedToCartProducts > 0
            "
          >
            <ion-accordion
              value="unavailable"
              toggleIconSlot="start"
              class="unavailable-section"
            >
              <ion-item slot="header" class="opu-section">
                <ion-label>
                  <div class="opu-section-title">
                    {{
                      'i18n.notifications.warehouseCuts.unavailableProducts'
                        | translate
                    }}
                    ({{
                      orderProductUnavailableViewModel?.unavailableProducts
                    }})
                  </div>
                  <ion-item class="opu-section">
                    <ion-icon
                      slot="start"
                      name="alert-circle-outline"
                      color="danger"
                      class="opu-section-icon"
                    ></ion-icon>
                    <ion-label class="opu-section-description">
                      {{
                        'i18n.notifications.warehouseCuts.unavailableProductsDescription'
                          | translate
                      }}
                    </ion-label>
                  </ion-item>
                </ion-label>
              </ion-item>
              <div
                class="unavailable-product-card-container"
                slot="content"
                *ngFor="
                  let cutProduct of orderProductUnavailableViewModel?.cutProducts;
                  last as lastItem;
                  index as i;
                  trackBy: trackByCutProduct
                "
                [ngClass]="cutProduct.isSelected ? 'selected' : ''"
              >
                <app-usf-checkbox
                  *ngIf="!cutProduct.original?.processed"
                  class="unavailable-product-card-checkbox"
                  [isSelected]="cutProduct.isSelected"
                  (selectEmitter)="selectItem(cutProduct, i)"
                ></app-usf-checkbox>
                <app-ordered-product-unavailable-item-card
                  class="product-card"
                  [cutProduct]="cutProduct"
                  (productSelect)="selectItem(cutProduct, i)"
                >
                </app-ordered-product-unavailable-item-card>
              </div>
            </ion-accordion>
          </ion-accordion-group>
          <ion-accordion-group
            *ngIf="orderProductUnavailableViewModel?.substitutedProducts > 0"
            class="opu-sections"
            value="substituted"
          >
            <ion-accordion
              value="substituted"
              toggleIconSlot="start"
              class="unavailable-section"
            >
              <ion-item slot="header" class="opu-section">
                <ion-label class="opu-section-title">
                  {{
                    'i18n.notifications.warehouseCuts.substitutedProducts'
                      | translate
                  }}
                  ({{ orderProductUnavailableViewModel?.substitutedProducts }})
                  <p>
                    <ion-item class="opu-section">
                      <ion-icon
                        slot="start"
                        name="alert-circle-outline"
                        color="danger"
                        class="opu-section-icon"
                      ></ion-icon>
                      <ion-label class="opu-section-description">
                        {{
                          'i18n.notifications.warehouseCuts.substitutedProductsDescription'
                            | translate
                        }}
                      </ion-label>
                    </ion-item>
                  </p>
                </ion-label>
              </ion-item>
              <div
                class="unavailable-subbed-card-container"
                slot="content"
                *ngFor="
                  let productSubstitution of orderProductUnavailableViewModel?.productSubstitutions;
                  last as lastItem;
                  trackBy: trackBySubstitution
                "
              >
                <app-product-substitution-card
                  class="product-card"
                  [productSubstitution]="productSubstitution"
                >
                </app-product-substitution-card>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
        <ion-col
          size="3"
          *ngIf="
            platformService.platformType ===
              platformService.platformEnum.desktop &&
            orderProductUnavailableViewModel?.cutProductsSummary as summary
          "
        >
          <div class="opu-selected-section">
            <ion-label class="opu-selected-label">
              {{ summary.selectedCount }} of
              {{ orderProductUnavailableViewModel?.unavailableProducts }}
              {{ 'i18n.notifications.warehouseCuts.selected' | translate }}
            </ion-label>
            <p class="opu-products-label">
              <ion-label>
                {{ 'i18n.notifications.warehouseCuts.products' | translate }}
              </ion-label>
            </p>
            <p class="opu-totals-value">
              <ion-label class="opu-totals-label">
                {{ 'i18n.notifications.warehouseCuts.totalCases' | translate }}
              </ion-label>
              <ion-label>{{ summary.totalCases }} CS</ion-label>
            </p>
            <p class="opu-totals-value">
              <ion-label class="opu-totals-label">
                {{ 'i18n.notifications.warehouseCuts.totalEaches' | translate }}
              </ion-label>
              <ion-label>{{ summary.totalEaches }} EA</ion-label>
            </p>
            <div class="opu-button-container">
              <ion-button
                [ngClass]="
                  summary.selectedCount === 0
                    ? 'usf-fill-disabled-button'
                    : 'usf-fill-green-button'
                "
                [disabled]="summary.selectedCount === 0"
                (click)="updateWarehouseDetails(null, null, null, null)"
              >
                {{
                  'i18n.notifications.warehouseCuts.addToNextDelivery'
                    | translate
                }}
              </ion-button>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row
        class="opu-selected-mobile-section"
        *ngIf="
          platformService.platformType !==
            platformService.platformEnum.desktop &&
          orderProductUnavailableViewModel?.cutProductsSummary as summary
        "
      >
        <ion-col>
          <ion-item class="opu-selected-mobile">
            <div slot="start">
              <ion-label class="opu-selected-label">
                {{ summary.selectedCount }} of
                {{ orderProductUnavailableViewModel?.unavailableProducts }}
                {{ 'i18n.notifications.warehouseCuts.selected' | translate }}
              </ion-label>
              <p>
                <ion-label>
                  {{ 'i18n.notifications.warehouseCuts.products' | translate }}:
                  {{ summary.totalCases + summary.totalEaches }} ({{
                    summary.totalCases
                  }}
                  CS / {{ summary.totalEaches }} EA)
                </ion-label>
              </p>
            </div>
            <ion-button
              [ngClass]="
                summary.selectedCount === 0
                  ? 'usf-fill-disabled-button'
                  : 'usf-fill-green-button'
              "
              [disabled]="summary.selectedCount === 0"
              (click)="updateWarehouseDetails(null, null, null, null)"
              slot="end"
            >
              {{
                'i18n.notifications.warehouseCuts.addToNextDelivery' | translate
              }}
            </ion-button>
          </ion-item>
        </ion-col>
      </ion-row>
    </div>
  </ion-col>
</ng-container>
